module.exports = __webpack_public_path__ + "static/img/IndustryTrends.4716203d.jpg";